<script setup lang="js">
import Button from "@/base-components/Button";
import Lucide from "@/base-components/Lucide";
import {uri} from "@/constants/config.js";
import {useFetch} from "@/composables/useFetch.js";
const domains = defineModel()
async function changeState(idx) {
  const isActive = !domains.value[idx].isActive
  const {data} = await useFetch(`${uri.admin.cloud.domain}/${domains.value[idx].id}`, {body: {isActive}, method: "PATCH"})
  domains.value[idx] = data
}
</script>

<template>
  <div
      class="rounded-lg p-6 space-y-4 border border-gray-200 shadow-sm hover:shadow-md transition-shadow relative box"
  >
    <div class="w-full my-3 flex flex-row  pe-6 lg:pe-6 xl:pe-0">
      <h3 class="text-base my-2 font-semibold w-32">
        Domains
      </h3>
      <div class="w-full text-end items-end justify-end">
        <Button variant="outline-secondary" size="sm" class="w-36">
          <Lucide icon="Plus" class="w-4 h-4 mr-2"/>
          {{ $t("button.add-domain") }}
        </Button>
      </div>
    </div>
    <!--Domain Section-->
    <div class="justify-between items-center mt-4 border-t">

      <div class="w-full">
        <div class="" v-if="domains && domains.length > 0">
          <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 xl:grid-cols-4 lg:grid-cols-3 gap-4">
            <div
                class="rounded-lg p-6 space-y-4 border border-gray-200 shadow-sm hover:shadow-md transition-shadow relative box"
                v-for="(domain, idx) in domains"
                :key="domain.id"
                dir="ltr"
            >
              <!-- Header Section -->
              <div class="flex items-center justify-between border-b pb-2 mb-4">
                <div class="w-full   gap-2">
                  <h2 class="text-xl font-semibold text-gray-800">{{ domain.displayName }} </h2>
                </div>
                <div class="w-36 -mt-3">
                  <span class="text-sm text-gray-500">{{ domain.name }}</span>
                  <Button :variant="domain.isActive?'primary':'outline-warning'" size="sm" class="w-16" @click="changeState(idx)">
                    {{ domain.isActive ? $t("title.active") : $t("title.inactive") }}
                  </Button>
                </div>
              </div>

              <!-- Middle Data Fields -->
              <!-- Middle Data Fields -->
              <div class=" gap-4">
                <div class="flex flex-row mb-4">
                  <div class="w-full">
                    <p class="text-gray-500 text-sm">
                      Chamber Type
                    </p>
                    <p class="font-medium text-gray-800">
                      {{ domain.chamberType }}
                    </p>
                  </div>
                  <div class="w-36">
                    <p class="text-gray-500 text-sm"></p>
                    <p class="font-medium text-gray-800" v-if="domain.isReseller===0">
                      Reseller
                    </p>
                  </div>
                </div>
                <!-- Bottom Data Fields - Configuration -->
                <div class="mt-4 ">
                  <div class="flex flex-col">
                    <p class="text-gray-500 text-sm">Entry Points</p>
                    <ul class="font-medium text-gray-800">
                      <li v-for="entryPoint in (domain.config).entryPoints" :key="entryPoint">{{
                          entryPoint
                        }}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else>
          Empty
        </div>

      </div>
    </div>
  </div>
</template>

<style scoped>

</style>